import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PurchaseIncomeDetailState } from '@/pages/mortgage/types/Purchase';

const initialState: {
  dataPopulated: boolean;
  incomeDetail: PurchaseIncomeDetailState;
} = {
  dataPopulated: false,
  incomeDetail: {
    incomeSource: null,
    nonPropertyLoan: null,
    whereDidYouHearAboutUs: null,
    creditCardCurrency: null,
    creditCardLimit: null,
    userMessage: null,
    taxBenefitAwareness: null,

    jobStartMonth: null,
    jobStartYear: null,
    occupation: null,
    salaryCurrency: null,
    companySalaryCurrency: null,
    baseSalary: null,
    salaryFrequency: null,
    receiveAllowanceIncome: null,
    receiveCommissionIncome: null,
    receiveAnnualCashBonus: null,
    receiveStockUnit: null,

    industry: null,
    operationStartMonth: null,
    operationStartYear: null,
    thisYearPersonalNetIncomeAfterTaxes: null,
    lastYearPersonalNetIncomeAfterTaxes: null,
    thisYearPersonalNetIncomeBeforeTaxes: null,
    lastYearPersonalNetIncomeBeforeTaxes: null,
    ownershipPercentage: null,
    thisYearCompanyNetIncomeAfterTaxes: null,
    lastYearCompanyNetIncomeAfterTaxes: null,

    allowanceIncome: null,
    allowanceFrequency: null,
    typeOfAllowanceIncome: null,

    commissionIncome: null,
    commissionFrequency: null,
    commissionYears: null,

    lastYearAnnualCashBonus: null,
    thisYearAnnualCashBonus: null,
    lastYearStockOptions: null,
    thisYearStockOptions: null,

    //   Coapplicant
    coapplicantExists: null,
    coapplicantNonPropertyLoan: null,
    coapplicantIncomeSource: null,
    coapplicantCreditCardCurrency: null,
    coapplicantCreditCardLimit: null,
    coapplicantJobStartMonth: null,
    coapplicantJobStartYear: null,
    coapplicantOccupation: null,
    coapplicantSalaryCurrency: null,
    coapplicantCompanySalaryCurrency: null,
    coapplicantBaseSalary: null,
    coapplicantSalaryFrequency: null,
    coapplicantReceiveAllowanceIncome: null,
    coapplicantAllowanceIncome: null,
    coapplicantAllowanceFrequency: null,
    coapplicantTypeOfAllowanceIncome: null,
    coapplicantReceiveCommissionIncome: null,
    coapplicantCommissionFrequency: null,
    coapplicantCommissionYears: null,
    coapplicantCommissionIncome: null,
    coapplicantReceiveAnnualCashBonus: null,
    coapplicantThisYearAnnualCashBonus: null,
    coapplicantLastYearAnnualCashBonus: null,

    coapplicantReceiveStockUnit: null,
    coapplicantThisYearStockOptions: null,
    coapplicantLastYearStockOptions: null,

    coapplicantIndustry: null,
    coapplicantOperationStartMonth: null,
    coapplicantOperationStartYear: null,

    coapplicantThisYearPersonalNetIncomeAfterTaxes: null,
    coapplicantLastYearPersonalNetIncomeAfterTaxes: null,

    coapplicantOwnershipPercentage: null,
    coapplicantThisYearCompanyNetIncomeAfterTaxes: null,
    coapplicantLastYearCompanyNetIncomeAfterTaxes: null,

    coapplicantVisaSubClass: null,
    coapplicantVisaExpiryDate: null,

    coapplicantThisYearPersonalNetIncomeBeforeTaxes: null,
    coapplicantLastYearPersonalNetIncomeBeforeTaxes: null,

    coapplicantThisYearCompanyNetIncomeBeforeTaxes: null,
    coapplicantLastYearCompanyNetIncomeBeforeTaxes: null,

    // Applicant Non Property Loan
    nonPropertyLoanType1: null,
    nonPropertyLoanCurrency1: null,
    nonPropertyLoanBalance1: null,
    nonPropertyLoanRepaymentTerm1: null,
    nonPropertyLoanRepaymentSum1: null,
    nonPropertyLoanRepaymentFrequency1: null,

    nonPropertyLoanType2: null,
    nonPropertyLoanCurrency2: null,
    nonPropertyLoanBalance2: null,
    nonPropertyLoanRepaymentTerm2: null,
    nonPropertyLoanRepaymentSum2: null,
    nonPropertyLoanRepaymentFrequency2: null,

    nonPropertyLoanType3: null,
    nonPropertyLoanCurrency3: null,
    nonPropertyLoanBalance3: null,
    nonPropertyLoanRepaymentTerm3: null,
    nonPropertyLoanRepaymentSum3: null,
    nonPropertyLoanRepaymentFrequency3: null,

    nonPropertyLoanType4: null,
    nonPropertyLoanCurrency4: null,
    nonPropertyLoanBalance4: null,
    nonPropertyLoanRepaymentTerm4: null,
    nonPropertyLoanRepaymentSum4: null,
    nonPropertyLoanRepaymentFrequency4: null,

    nonPropertyLoanType5: null,
    nonPropertyLoanCurrency5: null,
    nonPropertyLoanBalance5: null,
    nonPropertyLoanRepaymentTerm5: null,
    nonPropertyLoanRepaymentSum5: null,
    nonPropertyLoanRepaymentFrequency5: null,

    // Coapplicant Non Property Loan
    coapplicantNonPropertyLoanType1: null,
    coapplicantNonPropertyLoanCurrency1: null,
    coapplicantNonPropertyLoanBalance1: null,
    coapplicantNonPropertyLoanRepaymentTerm1: null,
    coapplicantNonPropertyLoanRepaymentSum1: null,
    coapplicantNonPropertyLoanRepaymentFrequency1: null,

    coapplicantNonPropertyLoanType2: null,
    coapplicantNonPropertyLoanCurrency2: null,
    coapplicantNonPropertyLoanBalance2: null,
    coapplicantNonPropertyLoanRepaymentTerm2: null,
    coapplicantNonPropertyLoanRepaymentSum2: null,
    coapplicantNonPropertyLoanRepaymentFrequency2: null,

    coapplicantNonPropertyLoanType3: null,
    coapplicantNonPropertyLoanCurrency3: null,
    coapplicantNonPropertyLoanBalance3: null,
    coapplicantNonPropertyLoanRepaymentTerm3: null,
    coapplicantNonPropertyLoanRepaymentSum3: null,
    coapplicantNonPropertyLoanRepaymentFrequency3: null,

    coapplicantNonPropertyLoanType4: null,
    coapplicantNonPropertyLoanCurrency4: null,
    coapplicantNonPropertyLoanBalance4: null,
    coapplicantNonPropertyLoanRepaymentTerm4: null,
    coapplicantNonPropertyLoanRepaymentSum4: null,
    coapplicantNonPropertyLoanRepaymentFrequency4: null,

    coapplicantNonPropertyLoanType5: null,
    coapplicantNonPropertyLoanCurrency5: null,
    coapplicantNonPropertyLoanBalance5: null,
    coapplicantNonPropertyLoanRepaymentTerm5: null,
    coapplicantNonPropertyLoanRepaymentSum5: null,
    coapplicantNonPropertyLoanRepaymentFrequency5: null,
  },
};

const purchaseSlice = createSlice({
  name: 'purchase',
  initialState,
  reducers: {
    setIncomeFormField: (
      state,
      action: PayloadAction<{
        field: keyof PurchaseIncomeDetailState;
        value: any;
      }>,
    ) => {
      const { field, value } = action.payload;
      state.incomeDetail[field] = value;
      state.dataPopulated = true;
    },
    resetIncomeFormField: (state) => {
      state.incomeDetail = initialState.incomeDetail;
      state.dataPopulated = false;
    },
  },
});

export default purchaseSlice.reducer;

export const { setIncomeFormField, resetIncomeFormField } =
  purchaseSlice.actions;
